
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AlertService, AccompanyingService, AuthenticationService } from '@app/core/services';

import { of, timer } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';

@Component({
    selector: 'modal-new-accompanying-document',
    templateUrl: 'modal-new-accompanying-document.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalNewAccompanyingDocument implements OnInit {
    form: FormGroup;
    model: any

    operatorId = null

    loading = false
    submitted = false

    isShowPasswordConfirm = false;

    constructor(
        public modal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private accompanyingService: AccompanyingService,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            customerName: ['', Validators.required],
            legalName: ['', Validators.required],
            folioFollowing: ['', {
                    validators: [Validators.required],
                    asyncValidators: [this.validateFolio.bind(this)]
                }
            ],
        })

        this.form.get('folioFollowing')?.valueChanges.subscribe(value => {
            if (value) {
                const upper = value.toUpperCase();
                if (value !== upper) {
                    this.form.get('folioFollowing')?.setValue(upper, { emitEvent: false });
                }
            }
        });
    }

    // Convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    validateFolio(control: AbstractControl) {
        if (!control.value) {
            return of(null);
        }

        return timer(400).pipe(
            switchMap(() =>
                this.accompanyingService.validateFolio(control.value)
            ),
            map(response => {
                return response.available ? null : { folioTaken: true }
            }),
            catchError(() => of(null))
        )
    }

    addModel(event) {
        this.model = event

        this.f.customerName.setValue(this.model.Name)
        this.f.legalName.setValue(this.model.Legal_Authority)

        this.operatorId = this.model.Id_Operator
    }

    onSubmit() {
        this.submitted = true
        
        if(this.form.invalid || this.form.pending) {
            return
        }

        this.loading = true

        const folioFollowing = this.form.value.folioFollowing

        this.accompanyingService.createAccompanyingRequest(this.operatorId, folioFollowing)
            .subscribe(
                response => {
                    this.alertService.success('Solicitud MTO-FDOC-05 creada', { autoClose: true, keepAfterRouteChange: true });
                    this.modal.close(true);
                    this.modal.dismiss();
                }, 
                error => {
                    this.loading = false
                    this.alertService.error(error, { autoClose: true });
                }
            )
    }
}

@Component({
    selector: 'modal-delete-accompanying-document',
    templateUrl: 'modal-delete-accompanying-document.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalDeleteAccompanyingDocument implements OnInit {
    @Input() accompanyingId: number = null
    @Input() code: string = null

    form: FormGroup
    forbiddenId = false
    submitted = false
    loading = false

    isShowPasswordDelete: boolean = false

    constructor(
        public modal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,
        private accompanyingService: AccompanyingService,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            password: ['', Validators.required],
        })
    }

    // Convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true

        // Reset alerts on submit
        this.alertService.clear()

        // Stop here if form is invalid
        if (this.form.invalid) {
            return
        }

        // Set loaders and validators
        this.forbiddenId = false
        this.loading = true

        // Check password writing by user
        this.authenticationService.isPasswordValidated(this.form.value.password)
            .subscribe(
                response => {
                    // Reset alerts on submit
                    this.alertService.clear()

                    // CHeck if password is valid
                    if (response.validated) {
                        this.alertService.success('Contraseña valida', { autoClose: true })

                        // Delete Accompanying Document request
                        this.accompanyingService.deleteAccompanyingRequest(this.accompanyingId)
                            .subscribe(
                                responseAcc => {
                                    this.alertService.success('La solicitud a sido eliminada correctamente', { autoClose: true })
                                    this.modal.close(true)
                                    this.modal.dismiss()
                                },
                                errorAcc => {
                                    this.alertService.error(errorAcc, { autoClose: true })
                                    this.loading = false
                                }
                            )
                    } else {
                        // Update validator to show wrong password
                        this.forbiddenId = true
                    }
                },
                error => {
                    this.alertService.error(error, { autoClose: true })
                    this.loading = false
                }
            )
    }

    showPasswordDelete(): void {
        this.isShowPasswordDelete = !this.isShowPasswordDelete
    }
}

@Component({
    selector: 'modal-sign-accompanying-document',
    templateUrl: 'modal-sign-accompanying-document.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalSignAccompanyingDocument implements OnInit {
    @Input() code: string = null

    form: FormGroup
    forbiddenId = false
    submitted = false
    loading = false

    isShowPassword: boolean = false

    constructor(
        public modal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            password: ['', Validators.required],
        })
    }

    // Convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true

        // Reset alerts on submit
        this.alertService.clear()

        // Stop here if form is invalid
        if (this.form.invalid) {
            return
        }

        // Set loaders and validators
        this.forbiddenId = false
        this.loading = true

        // Check password writing by user
        this.authenticationService.isPasswordValidated(this.form.value.password)
            .subscribe(
                response => {
                    // Reset alerts on submit
                    this.alertService.clear()

                    // CHeck if password is valid
                    if (response.validated) {
                        this.alertService.success('Contraseña valida', { autoClose: true })
                        this.modal.close(true)
                        this.modal.dismiss()
                    } else {
                        // Update validator to show wrong password
                        this.forbiddenId = true
                    }
                },
                error => {
                    this.alertService.error(error, { autoClose: true })
                    this.loading = false
                }
            )
    }

    showPassword(): void {
        this.isShowPassword = !this.isShowPassword
    }
}

@Component({
    selector: 'modal-sign-accompanying-document',
    templateUrl: 'modal-sign-accompanying-document.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalValidateAccompanyingDocument implements OnInit {
    @Input() code: string = null

    form: FormGroup
    forbiddenId = false
    submitted = false
    loading = false

    isShowPassword: boolean = false

    constructor(
        public modal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private alertService: AlertService,
        private authenticationService: AuthenticationService,
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            password: ['', Validators.required],
        })
    }

    // Convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true

        // Reset alerts on submit
        this.alertService.clear()

        // Stop here if form is invalid
        if (this.form.invalid) {
            return
        }

        // Set loaders and validators
        this.forbiddenId = false
        this.loading = true

        // Check password writing by user
        this.authenticationService.isPasswordValidated(this.form.value.password)
            .subscribe(
                response => {
                    // Reset alerts on submit
                    this.alertService.clear()

                    // CHeck if password is valid
                    if (response.validated) {
                        this.alertService.success('Contraseña valida', { autoClose: true })
                        this.modal.close(true)
                        this.modal.dismiss()
                    } else {
                        // Update validator to show wrong password
                        this.forbiddenId = true
                    }
                },
                error => {
                    this.alertService.error(error, { autoClose: true })
                    this.loading = false
                }
            )
    }

    showPassword(): void {
        this.isShowPassword = !this.isShowPassword
    }
}

@Component({
    selector: 'modal-upload-attachment-accompanying-document',
    templateUrl: 'modal-upload-attachment-accompanying-document.component.html',
    styleUrls: ['../../../app.component.scss']
})
export class ModalUploadAttachmentAccompanyingDocument implements OnInit {
    @Input() accompanyingId: number = 0
    @Input() code: string = null

    // Files
    file: File = null

    // Loaders
    loading: boolean = false
    
    // Validators
    fileSizeError: boolean = false;
    submitted: boolean = false

    // Constants
    maxFileSize = 15 * 1024 * 1024; // 15 MB

    constructor(
        public modal: NgbActiveModal,
        private alertService: AlertService,
        private accompanyingService: AccompanyingService,
    ) {}

    ngOnInit(): void {}

    onFileSelected(event: any) {
        const selectedFile = event.target.files[0]

        this.fileSizeError = false

        if (!selectedFile) {
            this.file = null
            return
        }

        // Validate size file
        if (selectedFile.size > this.maxFileSize) {
            this.alertService.error('El archivo excede el tamaño máximo permitido (15 MB)')
            this.fileSizeError = true
            event.target.value = null
            this.file = null
            return
        }

        // Validate MIME type file
        if (selectedFile.type !== 'application/pdf') {
            this.alertService.error('Solo se permiten archivos PDF')
            event.target.value = null
            this.file = null
            return
        }

        this.file = selectedFile
    }

    removeUploadingFile(fileInput: HTMLInputElement) {
        fileInput.value = null
        this.file = null
    }

    onSubmit() {
        this.submitted = true

        // Reset alerts on submit
        this.alertService.clear()

        // Stop here if form is invalid
        if (this.file === null) {
            return
        }

        // Set loaders
        this.loading = true

        this.accompanyingService.uploadAttachmentAccompanyingDocument(this.accompanyingId, this.file)
            .subscribe(
                response => {
                    if(response.success) {
                        this.modal.close(true)
                        this.modal.dismiss()
                    } else {
                        this.alertService.error('Error al subir archivo', { autoClose: true })
                    }
                },
                error => {
                    this.alertService.error(error, { autoClose: true })
                }
            )
    }
}